<template>
  <div class="ChoiceQuestion">
    <div class="title fs20">{{pindex}}. {{problem.problem.title}}</div>
    <div class="answer">
      <template v-for="(p, index) in problem.problem.options">
        <div>
          <input
            v-if="problem.problem_type == 'single-choice'"
            type="radio"
            :name="problem.problem_id"
            :id="`${problem.problem_id}-${index}`"
            :value="index"
            v-model="single"
            @click="choice(index, 'single')"
          />
          <input
            v-if="problem.problem_type == 'multiple-choice'"
            type="checkbox"
            :name="problem.problem_id"
            :id="`${problem.problem_id}-${index}`"
            v-model="multiple"
            :value="index"
            @change="choice(index, 'multiple')"
          />
          <label :for="`${problem.problem_id}-${index}`">{{String.fromCharCode(65 + index)}}. {{p}}</label>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Selection',
  props: ['problem', 'pindex', 'savedAnswer'],
  data () {
    return {
      single: '',
      multiple: []
    }
  },
  mounted () {
    if (this.savedAnswer) {
      if (this.problem.problem_type == 'single-choice') {
        this.single = this.savedAnswer[0]
      } else {
        this.multiple = this.savedAnswer
      }
    }
  },
  watch: {
    savedAnswer () {
      if (this.savedAnswer) {
        if (this.problem.problem_type == 'single-choice') {
          this.single = this.savedAnswer[0]
        } else {
          this.multiple = this.savedAnswer
        }
      }
    }
  },
  methods: {
    choice (index, tpe) {
      let data = new FormData();
      data.set('problem_id', this.problem.exam_problem_id);
      if (tpe == 'single') {
        console.log(this.problem.exam_problem_id, index)
        data.set('answer[]', index);
      } else {
        console.log(this.problem.exam_problem_id, this.multiple)
        const sorted = this.multiple.sort()
        sorted.forEach(item => {
          data.append('answer[]', item);
        })
      }
      this.$http.post('/api/exam/answer', data).then(res => {
        console.log(res)
      })
    }
  }
}
</script>
<style scoped>
.ChoiceQuestion {
  margin-bottom: 40px;
}

.title {
  font-size: 20px;
  margin-bottom: 15px;
}
.answer {
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
